import CookieConsentDescription from "./CookieConsentDescription";

export default CookieConsentDescription;
